import React, { useState, createContext, useContext } from 'react';
import { trackLanguageChange } from '../utils/analytics';
export type Language = 'fr' | 'en';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('fr');
  const handleSetLanguage = (lang: Language) => {
    setLanguage(lang);
    trackLanguageChange(lang);
  };
  return <LanguageContext.Provider value={{
    language,
    setLanguage: handleSetLanguage
  }} data-id="element-195">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}